import React, { SVGProps, forwardRef, Ref } from 'react';

type Props = {
  title?: React.ReactNode;
  titleId?: string;
} & SVGProps<SVGSVGElement>;

function SVGStonly({ title, titleId, ...props }: Props, svgRef?: Ref<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 600 600"
      width="600"
      height="600"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect width="600" height="600" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M439.108 239.853C406.378 239.853 379.786 266.855 379.786 299.994C379.786 333.133 406.378 360.135 439.108 360.135C471.838 360.135 498.431 333.133 498.431 299.994C498.431 267.264 471.838 239.853 439.108 239.853Z"
        fill="#E2001F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M278.313 239.853H162.532C129.802 239.853 103.209 266.855 103.209 299.994C103.209 333.133 129.802 360.135 162.532 360.135H278.313C311.043 360.135 337.635 333.133 337.635 299.994C337.226 267.264 310.633 239.853 278.313 239.853Z"
        fill="#E2001F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M513.147 450.967H248.855C216.126 450.967 189.533 477.969 189.533 511.108C189.533 544.247 216.126 571.249 248.855 571.249H513.147C545.877 571.249 572.47 544.247 572.47 511.108C572.47 477.969 545.877 450.967 513.147 450.967Z"
        fill="#E2001F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M88.0732 450.964C55.3436 450.964 28.7507 477.966 28.7507 511.105C28.7507 544.244 55.3436 571.246 88.0732 571.246C120.803 571.246 147.396 544.244 147.396 511.105C147.396 477.966 120.803 450.964 88.0732 450.964Z"
        fill="#E2001F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M340.092 28.7493H261.541C228.812 28.7493 202.219 55.7513 202.219 88.8903C202.219 122.029 228.812 149.031 261.541 149.031H340.092C372.822 149.031 399.415 122.029 399.415 88.8903C399.006 56.1605 372.413 28.7493 340.092 28.7493Z"
        fill="#E2001F"
      />
    </svg>
  );
}

export default forwardRef(SVGStonly);
